import { render, staticRenderFns } from "./GoToBtn.vue?vue&type=template&id=2c90cfb0&"
import script from "./GoToBtn.vue?vue&type=script&lang=js&"
export * from "./GoToBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports